import icon from 'vue-svgicon';

icon.register({
    'bold/remove-circle': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0zm5.49 16.076a1 1 0 1 1-1.414 1.414l-3.9-3.9a.252.252 0 0 0-.354 0l-3.9 3.9a1.012 1.012 0 0 1-1.414 0 1 1 0 0 1 0-1.414l3.9-3.9a.249.249 0 0 0 0-.353l-3.9-3.9A1 1 0 0 1 7.924 6.51l3.9 3.9a.25.25 0 0 0 .354 0l3.9-3.9a1 1 0 1 1 1.412 1.414l-3.9 3.9a.249.249 0 0 0 0 .353z"/>`,
    },
});
